import { useNavigate } from "react-router-dom";
import AppShell from "../components/ui/AppShell";
import SectionHeader from "../components/ui/SectionHeader";
import StatusChip from "../components/ui/StatusChip";
import ActionCard from "../components/ui/ActionCard";
import { useAuth } from "../context/AuthContext";

function CustomerDashboard() {
  const navigate = useNavigate();
  const { profile } = useAuth();

  const quickActions = [
    {
      icon: "Bookings",
      title: "My Bookings",
      description: "Track service bookings, status updates, and order history.",
      actionLabel: "Open",
      onClick: () => navigate("/my-bookings"),
    },
    {
      icon: "Materials",
      title: "Materials",
      description: "Browse construction materials and place orders with confidence.",
      actionLabel: "Browse",
      onClick: () => navigate("/materials"),
    },
    {
      icon: "Settings",
      title: "Settings",
      description: "Manage profile, saved addresses, preferred language, and city.",
      actionLabel: "Open",
      onClick: () => navigate("/settings"),
    },
    {
      icon: "Planner",
      title: "Build Your House",
      description: "Estimate project budget, scope, and timeline for future work.",
      actionLabel: "Open",
      onClick: () => navigate("/build-your-house"),
    },
  ];

  return (
    <AppShell maxWidth="1100px">
      <div style={heroCard} className="dashboard-page__hero">
        <SectionHeader
          title="Customer Dashboard"
          subtitle={`Welcome, ${
            profile?.full_name || "Customer"
          }. Use this dashboard for bookings, material orders, saved addresses, and support.`}
          rightContent={<StatusChip label="Active Customer" tone="info" />}
          style={{ marginBottom: 0 }}
        />
      </div>

      <SectionHeader
        title="Quick Actions"
        subtitle="Jump into the most common customer flows with the same shared UI pattern used across the app."
        style={{ marginTop: "28px" }}
      />

      <div style={grid} className="dashboard-page__grid">
        {quickActions.map((item) => (
          <ActionCard
            key={item.title}
            icon={item.icon}
            title={item.title}
            description={item.description}
            actionLabel={item.actionLabel}
            onClick={item.onClick}
          />
        ))}
      </div>
    </AppShell>
  );
}

const heroCard = {
  background: "linear-gradient(135deg, #111, #191919)",
  border: "1px solid #222",
  borderRadius: "22px",
  padding: "28px",
  boxShadow: "0 18px 44px rgba(0,0,0,0.28)",
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: "16px",
};

export default CustomerDashboard;
